import { createOpenAPIClient } from "@marcuslongmuir/openapi-typescript-helpers";
import { venueServiceSchema } from "@teamtable/api";

export const apiClient = createOpenAPIClient(venueServiceSchema, {
  baseUrl: window.serverConfig?.API_URL || window.location.origin,
  fetchOverride: (request: Request) => {
    return fetch(request, { credentials: "include" });
  },
});
